import { PageHeader } from "../../../components/PageHeader/PageHeader";
import { useEffect, useState } from "react";
import Modal from "../../../components/Modal/Modal";
import { boardBgColors } from "../../../misc/constants";
import { boardActions } from "../../../actions/boards";
import { useGlobalUserState } from "../../../stores/user";
import { useNavigate } from "react-router-dom";
import { useBoards } from "../../../hooks/board";
import AddSquare from "../../../assets/icons/AddSquare";
import InputField from "../../../components/input-field/InputField";
import CheckMark from "../../../assets/icons/CheckMark";
import DefaultButton from "../../../components/default-button/DefaultButton";
import ArrowLeftWithBody from "../../../assets/icons/ArrowLeftWithBody";
import Tick from "../../../assets/icons/Tick";
import { BoardAdmin } from "./BoardAdmin";
import maleTeacher from "../../../assets/png/male-teacher-profile.png";
import AdminSelector from "../../../components/Boards/AdminSelector/AdminSelector";
export const Boards = () => {
  const userState = useGlobalUserState();
  const navigate = useNavigate();
  const userObj = userState.get();
  const user = userObj.user || {};
  const boards = useBoards();
  const [modalOpen, setModalOpen] = useState(false);
  const [boardBg, setBoardBg] = useState("");
  const [boardName, setBoardName] = useState("");
  const [visible, setVisible] = useState("");
  const [admins, setAdmins] = useState([]);

  useEffect(() => {
    if (boards && boards.length > 0) {
      navigate(`/admin/boards/${boards[0].id}`);
    }
  }, [boards, navigate]);


  const isFormValid =
    boardBg.trim() !== "" &&
    boardName.trim() !== "" &&
    visible.trim() !== "" &&
    admins.length > 0;

  const createBoard = async () => {
    const result = await boardActions.createBoard(boardName, boardBg);
    if (result.success) {
      navigate(`/admin/boards/${result.id}`);
    }
  };

  return (
    <div className="grid grid-cols-12 pt-5 px-10">
      <div className="col-span-12">
        <PageHeader />
      </div>
      <div className="col-span-12 flex flex-col mt-4 justify-start items-start overflow-x-auto pb-3">
        <p className="text-xl text-black font-semibold uppercase">
          Ваши рабочие пространства
        </p>
        <div className="flex flex-row mt-4">
          <div
            className="rounded-md shadow-container-1 bg-white py-6 px-24 flex flex-col items-center cursor-pointer"
            onClick={() => setModalOpen(true)}
          >
            <AddSquare additionalStyle="w-[30px] h-[30px]" />
            <p className="mt-2 text-xs font-medium text-[#353247] leading-5">
              Создать доску
            </p>
          </div>
          {boards.map((board) => (
            <div
              className={`rounded-md shadow-container-1 bg-white py-1.5 px-3 ml-4 flex flex-col cursor-pointer min-w-52 ${board.bg}`}
              onClick={() => navigate(`/admin/boards/${board.id}`)}
            >
              <p className="text-[19px] font-semibold text-valley-black">
                {board.name}
              </p>
            </div>
          ))}
        </div>
      </div>
      <Modal
        dimensions="w-2/5 h-2/5 rounded-[10px] p-7"
        visible={modalOpen}
        setVisible={setModalOpen}
        additionalClassName="!w-fit"
      >
        <div className="flex flex-col">
          <div className="flex flex-row justify-center">
            <p className="text-lg text-black font-semibold">Создать доску</p>
          </div>
          <p className="text-sm font-semibold text-black">Фон</p>
          <div className="flex flex-row mt-1.5">
            {boardBgColors.map((bg) => (
              <div
                className={`flex-1 h-[43px] ${bg} mr-5 rounded-md cursor-pointer ${
                  boardBg === bg ? "border-2 border-black" : ""
                }`}
                onClick={() => setBoardBg(bg)}
              />
            ))}
          </div>
          <div className="mt-6 flex flex-col gap-6">
            <InputField
              label="Название"
              type="text"
              additionalClassName="mt-1.5 rounded-md !bg-[#F0F3FA] text-black py-3 px-2 !placeholder-[#AFB7CA]"
              value={boardName}
              handleChange={(e) => setBoardName(e.target.value)}
              placeholder="Введите название доски"
            />
            <InputField
              label="Видимость"
              type="select"
              additionalClassName="mt-1.5 rounded-md !bg-[#F0F3FA] text-black py-3 px-2 !placeholder-[#AFB7CA]"
              value={visible}
              handleChange={(e) => setVisible(e.target.value)}
              placeholder="Введите название доски"
              options={[
                { value: "public", label: "Общедоступна" },
                { value: "private", label: "Приватная" },
              ]}
            />
          </div>

          <AdminSelector admins={admins} setAdmins={setAdmins} />
          <div className="mt-8 flex gap-3 text-nowrap">
            <DefaultButton
              buttonText="Вернуться"
              additionalStyle="bg-[#5F6B88] text-white px-12 py-3 gap-2"
              Icon={ArrowLeftWithBody}
              onClick={() => setModalOpen(false)}
            />
            <DefaultButton
              buttonText="Создать доску"
              additionalStyle={`px-12 py-3 gap-2 ${
                isFormValid
                  ? "bg-[#3BBC30] text-white"
                  : "bg-[#3BBC30] text-white opacity-30 cursor-not-allowed"
              }`}
              Icon={Tick}
              disabled={!isFormValid}
              onClick={createBoard}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};
